import "./login.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../redux/userSlice";
import { roleRoutes } from "../../config/roles";
import axiosInstance from "../../services/api";
import { setSchool } from "../../redux/schoolSlice";
import { setSessions } from "../../redux/sessionSlice";
import { useSnackbar } from "../../context/SnackbarContext";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { darkMode } = useSelector((state) => state.theme);
  const { showSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (username && password) {
      setLoading(true);
      try {
        const loginResponse = await axiosInstance.post("/auth/login", {
          username,
          password,
        });
        const res = await axiosInstance.get("/users/me");

        const user = res.data;
        dispatch(loginSuccess(user));
        // console.log(user);

        if (user.schoolId) {
          const res1 = await axiosInstance.get(`/schools/${user?.schoolId}`);
          if (loginResponse.data.subscription) {
            res1.data.subscription = loginResponse.data.subscription.subscription;
            res1.data.accessRole = loginResponse.data.subscription.accessRole;
          }
          dispatch(setSchool(res1.data));

          try {
            const res2 = await axiosInstance.get(
              `/schools/${user?.schoolId}/sessions`,
            );
            dispatch(setSessions(res2.data));
          } catch (sessionError) {
            if (sessionError.response?.status !== 403) throw sessionError;
            dispatch(setSessions([]));
          }
        }

        // Redirect based on role
        const path = roleRoutes[user.role] || "/";
        navigate(path, { replace: true });
      } catch (err) {
        setLoading(false);
        showSnackbar(
          "Wrong credentials. Please enter the correct credentials.",
          "error",
        );
      }
    } else {
      showSnackbar("Enter the credentials.", "warning");
    }
  };

  return (
    <div className="loginPage">
      <div className="loginCard">
        <div className="loginImage">
          <img src="images/brand.png" alt="Login illustration" />
        </div>

        <div className="loginForm">
          <div className="brand">
            <img
              className="logo"
              src={
                darkMode
                  ? `${process.env.PUBLIC_URL}/images/logo-white.png`
                  : `${process.env.PUBLIC_URL}/images/logo.png`
              }
              alt="Logo"
            />
          </div>

          <h2>Secure access to your dashboard.</h2>
          <p className="subtitle">Sign in with your username and password.</p>

          <form onSubmit={handleLogin}>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              placeholder="Enter your username"
              onChange={(e) => setUsername(e.target.value)}
            />

            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              onChange={(e) => setPassword(e.target.value)}
            />

            <button disabled={loading} type="submit" className="submitBtn">
              SIGN IN
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
